import { IView } from "@formant/core/model/IView";

/**
 * A new, unsaved view starting from an existing one. An organization has a
 * single org-level view, so the copy never inherits that level (the API
 * answers 409 for a second one); group and device levels carry over.
 */
export function copyView(view: IView): IView {
    // The pinned @formant/core IView predates the level field.
    const { level } = view as IView & { level?: string | null };
    return {
        ...view,
        id: undefined,
        ...(level === "org" ? { level: undefined } : {}),
    };
}
